import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBuilding,
  faChartLine,
  faClipboard,
  faClipboardList,
  faDollarSign,
  faFilePen,
  faFileInvoiceDollar,
  faFolder,
  faFolderOpen,
  faGasPump,
  faGear,
  faHandHoldingDollar,
  faMagnifyingGlass,
  faTruck,
  faUserTie,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';

// Iconos que el backend envía dinámicamente (tabla Autenticacion.Icono).
// Si se agrega un nuevo icono en una migración, agregarlo aquí también.
library.add(
  faBuilding,
  faChartLine,
  faClipboard,
  faClipboardList,
  faDollarSign,
  faFilePen,
  faFileInvoiceDollar,
  faFolder,
  faFolderOpen,
  faGasPump,
  faGear,
  faHandHoldingDollar,
  faMagnifyingGlass,
  faTruck,
  faUserTie,
  faUsers
);
